import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '@environments/environment';
import { Store } from '@ngxs/store';
import { WitnessSignatureRequest } from '@shared/models/interfaces/witnessSignature.interface';
import { HttpService } from '@shared/providers/http.service';

@Injectable({
  providedIn: 'root'
})
export class WitnessSignatureService extends HttpService {
  constructor(httpClient: HttpClient, store: Store) {
    super(environment.endpoints.witnessSignature, httpClient, store);
  }
  getWitnessSignatureData(signatureId: string): Promise<any> {
    return this.getAsyncV2<any>(`/${signatureId}`);
  }

  update(witnessSignature: WitnessSignatureRequest, signatureId: string): Promise<any> {
    return this.putAsyncV3(witnessSignature, `/${signatureId}`);
  }

  resendToken(signatureId: string): Promise<any> {
    return this.getAsync<any>(`/resend/${signatureId}`);
  }
}
